import { WaitingIcon } from '../icons'

const PendingIndicator = () => {
	return (
		<>
			<div className="ml-2 flex w-fit items-center gap-x-1 rounded-full bg-[#EFB615] px-2.5 py-0 md:hidden">
				Pending
			</div>
			<div className="ml-2 hidden h-full w-fit px-2.5 py-0 md:block">
				<div className="flex h-full items-center">
					<WaitingIcon />
				</div>
			</div>
		</>
	)
}

export default PendingIndicator
